import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ButtonCta from '@components/atoms/button-cta'
import InfoCardVariant from '@components/info-and-image-card-with-overlay/info-card-variant'
import useStyles from './career-tracks-variant.styles'

const CareerTracksVariant = (props) => {
  const {
    sectionHeading,
    overline,
    subtitle,
    ctaButtonLabel,
    ctaButtonLink,
    trackCardsCollection,
  } = props
  const styles = useStyles()

  return (
    <div data-testid="career-tracks-variant" className={styles.root}>
      <div className={styles.introContainer}>
        <div>
          <Typography variant="overline" className={styles.overline}>{overline}</Typography>
          <h2 className={styles.heading}>{sectionHeading}</h2>
          <p className={styles.supportiveCopy}>{subtitle}</p>
        </div>
        {(ctaButtonLink && ctaButtonLabel) && (
          <div className={styles.ctaContainer}>
            <ButtonCta
              href={ctaButtonLink}
              variant="contained"
              color="primary"
            >
              {ctaButtonLabel}
            </ButtonCta>
          </div>
        )}
      </div>
      <Grid container spacing={3} className={styles.cardGrid}>
        {trackCardsCollection?.items
          && trackCardsCollection.items.map((cardData, i) => (
            <InfoCardVariant {...cardData} key={`career-tracks-card-${i + 1}`} />
          ))}
      </Grid>
    </div>
  )
}

CareerTracksVariant.propTypes = {
  careerTracksSection: PropTypes.object,
  sectionHeading: PropTypes.string,
  overline: PropTypes.string,
  subtitle: PropTypes.string,
  ctaButtonLabel: PropTypes.string,
  ctaButtonLink: PropTypes.string,
  trackCardsCollection: PropTypes.object,
}

export default CareerTracksVariant
